import { getWithToken } from 'api/network';

export async function GetEventHistory(asgPropID, livingAreaSqFt) {
    const url = `/api/explore/GetEventHistory?asgPropID=${asgPropID}&LivingAreaSqFt=${livingAreaSqFt}`;
    const response = await getWithToken(url);
    const data = await response.json();
    return data;
}